/**
 * Hand-maintained typed operations used by non-generated commands.
 * These need gql() for TypedDocumentNode inference.
 */
import { gql } from '../generated/gql.ts';

export const Me = gql(`
  query Me {
    me {
      id
      email
      firstName
      lastName
    }
  }
`);
